// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bhc_a bhr_h","Menu__offsetParent":"bhc_b bhr_bj","Menu__trigger--shadowed":"bhc_c"};